import { firstValueFrom } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { CHAT_MESSAGE_TYPE, hasDeliveryDetails, IOrder } from '@cakeiteasy/web-utils';
import { OrderOverviewApiService } from './services/order-overview-api.service';
import { OrderOverviewChatGateway } from './services/order-overview-chat.gateway';
import { CHAT_CONVERSATION_GATEWAY } from '../order-chat/services/chat-conversation-gateway';
import { IChatConversation } from '../order-chat/models/i-chat-conversation.interface';

@Component({
  standalone: false,
  selector: 'order-overview',
  templateUrl: './order-overview.component.html',
  styleUrls: ['./order-overview.component.scss'],
  providers: [
    OrderOverviewApiService,
    OrderOverviewChatGateway,
    { provide: CHAT_CONVERSATION_GATEWAY, useExisting: OrderOverviewChatGateway },
  ],
})
export class OrderOverviewComponent implements OnInit {
  @Input() orderId: string;

  public readonly tabs = {
    ORDER: 'ORDER',
    MESSAGE: 'MESSAGE',
  };

  public activeTab = this.tabs.ORDER;
  public order: IOrder;
  public showDeliveryDetails = false;
  public viewCanBeShown = false;
  public conversation: IChatConversation;

  public busy: Promise<unknown>;
  public CHAT_MESSAGE_TYPE = CHAT_MESSAGE_TYPE;

  constructor(private _orderOverviewApi: OrderOverviewApiService,
              private _chatGateway: OrderOverviewChatGateway) {
  }

  async ngOnInit() {
    this._chatGateway.orderId = this.orderId;
    this.busy = this.initialize();
  }

  public setBusy(busy: Promise<unknown>) {
    this.busy = busy;
  }

  public setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  private async initialize() {
    const order = await firstValueFrom(this._orderOverviewApi.getOffer(this.orderId));
    this.order = order;
    this.showDeliveryDetails = hasDeliveryDetails(order.deliveryOrder);

    this.conversation = { parentOrderId: order.multiOrder?.id, customerKey: order.orderRequest?.id };

    this.viewCanBeShown = true;
  }
}
